import { UIHeading2 } from '@cian/ui-kit';

import { type FC, type PropsWithChildren } from 'react';

export const Title: FC<PropsWithChildren> = ({ children }) => {
  return <UIHeading2 as="h1">{children}</UIHeading2>;
};
